"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = LandingPageCard;

var React = _interopRequireWildcard(require("react"));

var _LoadSVG = _interopRequireDefault(require("../../../components/LoadSVG"));

var _InlineSvg = _interopRequireDefault(require("../../../components/InlineSvg"));

var _reactRouterDom = require("react-router-dom");

var _isUrlExternal = _interopRequireDefault(require("is-url-external"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Wrapper = function Wrapper(_ref) {
  var disabled = _ref.disabled,
      className = _ref.className,
      children = _ref.children,
      to = _ref.to,
      openInTab = _ref.openInTab,
      onClickHandler = _ref.onClickHandler;
  var target = openInTab ? '_blank' : '_self';

  var handleClick = function handleClick(e) {
    if (onClickHandler && typeof onClickHandler === 'function') {
      onClickHandler();
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, disabled ? /*#__PURE__*/React.createElement("div", {
    className: className
  }, children) : /*#__PURE__*/React.createElement(React.Fragment, null, (0, _isUrlExternal["default"])(to) ? /*#__PURE__*/React.createElement("a", {
    className: className,
    onClick: handleClick,
    href: to,
    target: target
  }, children) : /*#__PURE__*/React.createElement(_reactRouterDom.Link, {
    className: className,
    onClick: handleClick,
    to: to,
    target: target
  }, children)));
};

function LandingPageCard(props) {
  var communityImages = props.communityImages,
      to = props.to,
      blurred = props.blurred,
      image = props.image,
      introText = props.introText,
      title = props.title,
      disabled = props.disabled,
      _props$openInTab = props.openInTab,
      openInTab = _props$openInTab === void 0 ? false : _props$openInTab,
      onClickHandler = props.onClickHandler;
  return /*#__PURE__*/React.createElement(Wrapper, {
    className: "landing-page-card " + (disabled ? 'disabled' : ''),
    disabled: disabled,
    to: to,
    openInTab: openInTab,
    onClickHandler: onClickHandler
  }, communityImages && /*#__PURE__*/React.createElement("div", {
    className: "landing-page-card__images " + (blurred ? 'blurred' : '')
  }, communityImages.map(function (image, key) {
    return /*#__PURE__*/React.createElement(_LoadSVG["default"], {
      key: key,
      src: image
    });
  }), blurred && /*#__PURE__*/React.createElement(_InlineSvg["default"], {
    name: "question",
    colour: "deepCyan",
    className: "landing-page-card__question"
  })), image && /*#__PURE__*/React.createElement(_LoadSVG["default"], {
    src: image
  }), introText && /*#__PURE__*/React.createElement("p", {
    className: "landing-page-card--intro-text"
  }, introText), /*#__PURE__*/React.createElement("h4", {
    className: "landing-page-card__title " + (disabled ? 'disabled' : '')
  }, title));
}